<template>
  <div>
    <div v-if="!showForm">
      <div class="tips">为了保障您的安全，需验证身份</div>
      <div style="width: 80%;margin: 0 auto;">
        <van-cell value="请选择一种验证方式" />
        <div style="margin-top: 15px;">
          <van-cell center title-style="font-size:28px;" :title="userinfo.mobile" label="通过手机验证码验证身份" icon="chat-o" @click="dosubmit" is-link />
        </div>
      </div>
    </div>
    <div v-else>
      <div class="tips">
        为了保障您的安全，需验证身份
        <span>
          验证码已发送至你的手机 {{ userinfo.mobile }}
        </span>
      </div>
      <!-- 密码输入框 -->
      <van-password-input
        :value="msgcode"
        :length="5"
        :mask="false"
        :focused="showKeyboard"
        @focus="showKeyboard = true"
      />
      <!-- 数字键盘 -->
      <van-number-keyboard
        :show="showKeyboard"
        @input="onInput"
        @delete="onDelete"
        @blur="showKeyboard = false"
      />
      <div style="text-align: center;margin: 15px;">
        <router-link :to="{name: 'ServiceRule'}" style="color: #42b983;">重新发送</router-link>
      </div>
      <div style="padding: 16px;">
        <van-button round block type="primary" @click="dosubmit2">
          提交
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  mapGetters
} from 'vuex'
import Vue from 'vue'
import { getUrlParams } from '../../utils/common'
import { PasswordInput, NumberKeyboard } from 'vant'
Vue.use(PasswordInput)
Vue.use(NumberKeyboard)
export default {
  data() {
    return {
      msgcode: '',
      showKeyboard: true,
      showForm: false
    }
  },
  computed: {
    ...mapGetters({
      userinfo: 'user/userinfo'
    })
  },
  methods: {
    dosubmit () {
      this.$api.global.getMsgCode(null, null, 'secondVerify')
        .then((res) => {
          if (res.data.code === 200) {
            this.showForm = true
          } else {
            this.$notify(res.data.message)
          }
        })
    },
    dosubmit2 () {
      this.$store.dispatch('user/secondVerify', { mobile: this.userinfo.mobile, msgcode: this.msgcode })
        .then((res) => {
          if (res.data.code === 200) {
            const redirect = getUrlParams('redirect')
            if (redirect) {
              top.window.location = decodeURIComponent(redirect)
            } else {
              this.$router.push({ name: 'UserCenter' })
            }
          } else {
            this.$notify(res.data.message)
          }
        })
    },
    onInput(key) {
      this.msgcode = (this.msgcode + key).slice(0, 5);
    },
    onDelete() {
      this.msgcode = this.msgcode.slice(0, this.msgcode.length - 1);
    }
  }
}
</script>
<style scoped lang="less">
  .tips{padding: 30px 25px;font-size: 22px;text-align: center;line-height: 30px;}
  .tips span {font-size: 13px;color: #999;}
</style>
